import React from 'react';
import PlateToolBar from '../../platewells/PlateToolBar';
import QlpPlateStatsDownLoad from '../../platewells/fileDownloads/QlpPlateStatsDownLoad';
import QlpFileDownload from '../../platewells/fileDownloads/QlpFileDownload';
import PlateWell from '../../platewells/PlateWell';

const Actions = () => {
    return (
        <>
            <div className="grid min-h-screen border-2 border-solid">
                <div className="flex flex-col w-full relative aspect[-1] ">
                    <div className="flex p-5">
                        <div className='flex-1'>
                            <PlateToolBar />
                        </div>
                        <div>
                            <QlpFileDownload />
                        </div>
                        <div>
                            <QlpPlateStatsDownLoad />
                        </div>
                    </div>
                    <div className="flex-grow overflow-auto">
                        <PlateWell />
                    </div>

                </div>
            </div >
            <div className="footer-area">

            </div>
        </>
    );
};

export default Actions;
